export default __webpack_public_path__ + "static/media/Favour Adekogbe.f92e9c00.png";